import React from "react";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import styles from "./ConfirmInfo.module.css";

import { useSelector } from "react-redux";

const ConfirmInfo = () => {
  const { pickupInfo } = useSelector((state) => state.savePickup);
  const { dropoffInfo } = useSelector((state) => state.saveDropoff);
  const { courierInfo } = useSelector((state) => state.saveCourier);

  const pickup = pickupInfo && pickupInfo;
  const dropoff = dropoffInfo && dropoffInfo;
  const courier = courierInfo && courierInfo;

  console.log(courier);

  return (
    <Layout title="Confirm Info" route={"/courier-info"}>
      <div className={styles.container}>
        <div className={styles.directionsContainer}>
          <div className={styles.iconsContainer}>
            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
            <span className={styles.line}></span>
            <i className={styles.icon + " fas fa-location-arrow"}></i>
          </div>
          <div className={styles.places}>
            <div className={styles.place}>
              <small>{pickup && pickup.Landmark}</small>
              <h2>{pickup && pickup.pickupName}</h2>
              <p>{pickup && pickup.pickupLocation}</p>
            </div>
            <div className={styles.place}>
              <small>{dropoff && dropoff.Landmark}</small>
              <h2>{dropoff && dropoff.dropoffName}</h2>
              <p>{dropoff && dropoff.dropoffLocation}</p>
            </div>
          </div>
        </div>

        {/* <div className={styles.distanceContainer}>
          <div className={styles.distance}>
            <small>Distance</small>
            <p>{courier.distance} km</p>
          </div>
          <div className={styles.viewMap}>
            <i className={styles.icon + " fas fa-location-arrow"}></i>
            <p>View in Map</p>
          </div>
        </div> */}

        <div className={styles.infoContainer}>
          <div className={styles.box}>
            <small>Distance</small>
            <p>{courier.distance} km</p>
          </div>
          <div className={styles.box}>
            <small>Price</small>
            <p>{courier.payment} Euro</p>
          </div>

          <div className={styles.box}>
            <small>Courier Type</small>
            <p>{courier && courier.type}</p>
          </div>
          <div className={styles.box}>
            <small>Frangible</small>
            <p>
              {courier && courier.isFragile ? (
                <span>Yes</span>
              ) : (
                <span>No</span>
              )}
            </p>
          </div>
          <div className={styles.box}>
            <small>Height Weight Length</small>
            <p>{courier && courier.lwh} (cm)</p>
          </div>
          <div className={styles.box}>
            <small>Weight</small>
            <p>{courier && courier.weight}</p>
          </div>
          <div className={styles.box}>
            <small>Courier Info</small>
            <p>{courier && courier.details}</p>
          </div>
        </div>
        <Link to="/payment-modes">
          <button className={styles.continueBtn}>
            Proceed to Payment
            <i className={styles.icon + " fas fa-long-arrow-alt-right"}></i>
          </button>
        </Link>
      </div>
    </Layout>
  );
};

export default ConfirmInfo;
